
import WebFont from 'webfontloader'

const options = {"custom":{"families":["Nunito+Sans:n4,n6,n9"],"urls":["https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Nunito+Sans:400,600,900&display=swap"]}}

WebFont.load(options)
